import gql from 'graphql-tag';

export default gql`
  query ShortedWaves($pickDate: String!) {
    shortedWaves(pickDate: $pickDate) {
      id
      name
      isFullyPublished
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/getShortedWaves.js